import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "objective-scroll-area" }
const _hoisted_2 = { style: {"position":"absolute","right":"25px","top":"12px","z-index":"1000"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Atualizar")
const _hoisted_4 = { style: {"position":"absolute","right":"80px","top":"12px","z-index":"1000"} }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  key: 0,
  class: "row q-col-gutter-x-sm"
}
const _hoisted_10 = { class: "col-6 q-pl-none" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = {
  key: 0,
  class: "col-12 col-md-6"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey-7 text-weight-bolder" }, " Selecione o periodo ")
], -1)
const _hoisted_16 = { class: "col flex justify-end" }
const _hoisted_17 = {
  key: 1,
  class: "text-blue-grey-9 text-weight-bold"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = {
  key: 2,
  class: "row"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey-7 text-weight-bolder" }, " Filtros Selecionados ")
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "row flex-center q-mt-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_help_btn = _resolveComponent("help-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_generic_select = _resolveComponent("generic-select")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_spinner_orbit = _resolveComponent("q-spinner-orbit")!
  const _component_q_range = _resolveComponent("q-range")!
  const _component_filter_banner = _resolveComponent("filter-banner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_objective_shower = _resolveComponent("objective-shower")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_card, {
        class: "shadow-5",
        style: {"width":"100%","max-width":"600px","margin-top":"5px","position":"relative"},
        "data-cy": "obj-filter-card"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_btn, {
              rounded: "",
              padding: "5px",
              size: "md",
              onClick: _ctx.refresh,
              color: "positive",
              push: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "refresh" })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_q_tooltip, { class: "bg-positive" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_help_btn)
          ]),
          _createVNode(_component_q_expansion_item, {
            "header-class": ['q-pa-md'],
            modelValue: _ctx.isFilterExpanded,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isFilterExpanded) = $event)),
            onBeforeHide: _ctx.doNotHideFilter,
            "data-cy": "obj-filter-expansion"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_q_item_section, { side: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, { class: "text-weight-bolder text-body1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.expansionTitle), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { side: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_badge, {
                    class: "q-pa-xs text-bold",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_q_item_label, {
                            key: 0,
                            "data-cy": "obj-filter-total"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.isReview ? _ctx.countWrongResult : _ctx.countResult), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_q_spinner, {
                            key: 1,
                            size: "xs",
                            color: "white",
                            "data-cy": "obj-filter-loading"
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_space)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "q-gutter-md" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_generic_select, {
                        "data-cy": "obj-filter-subject",
                        options: _ctx.subjects,
                        modelValue: _ctx.subjectSelected,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subjectSelected) = $event)),
                        label: "Selecione as disciplinas",
                        "use-input": ""
                      }, null, 8, ["options", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_generic_select, {
                        "data-cy": "obj-filter-topics",
                        color: "secondary",
                        options: _ctx.topics,
                        modelValue: _ctx.topicSelected,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.topicSelected) = $event)),
                        label: "Selecione os assuntos",
                        disable: _ctx.selectedSubjectIsDefault,
                        "use-input": ""
                      }, null, 8, ["options", "modelValue", "disable"])
                    ])
                  ]),
                  (!_ctx.isReview)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_q_select, {
                            outlined: "",
                            square: "",
                            modelValue: _ctx.historyFilter,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.historyFilter) = $event)),
                            options: _ctx.historyOptions,
                            label: "Histórico",
                            "emit-value": "",
                            "map-options": ""
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_generic_select, {
                            "data-cy": "obj-filter-topics",
                            color: "secondary",
                            options: _ctx.difficultyOptions,
                            modelValue: _ctx.difficultySelected,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.difficultySelected) = $event)),
                            label: "Dificuldade",
                            "use-input": ""
                          }, null, 8, ["options", "modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isReview)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (!_ctx.hideJury)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_generic_select, {
                                "data-cy": "obj-filter-history",
                                modelValue: _ctx.jurySelected,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.jurySelected) = $event)),
                                options: _ctx.jury,
                                label: "Banca",
                                "use-input": ""
                              }, null, 8, ["modelValue", "options"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["col-12 col-md-6 q-pa-md q-py-md-none q-px-md-md", { 'col-md-12': _ctx.hideJury }])
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_q_badge, {
                                class: "q-pa-xs",
                                color: "grey-3",
                                "data-cy": "obj-filter-timeline"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.isLoadingYears)
                                    ? (_openBlock(), _createBlock(_component_q_spinner_orbit, {
                                        key: 0,
                                        color: "white",
                                        size: "xs"
                                      }))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.timeline), 1))
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_q_range, {
                              "data-cy": "obj-filter-range",
                              markers: "",
                              snap: "",
                              min: _ctx.min,
                              max: _ctx.max,
                              modelValue: _ctx.range,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.range) = $event)),
                              step: 1
                            }, null, 8, ["min", "max", "modelValue"])
                          ])
                        ], 2)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.fieldsIsDefault)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                    : _createCommentVNode("", true),
                  (!_ctx.selectedSubjectIsDefault)
                    ? (_openBlock(), _createBlock(_component_filter_banner, {
                        key: 3,
                        "data-cy": "obj-filter-subject-banner",
                        label: "Disciplinas",
                        modelValue: _ctx.subjectSelected,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.subjectSelected) = $event)),
                        fn: _ctx.removeItem
                      }, null, 8, ["modelValue", "fn"]))
                    : _createCommentVNode("", true),
                  (!_ctx.selectedTopicIsDefault)
                    ? (_openBlock(), _createBlock(_component_filter_banner, {
                        key: 4,
                        "data-cy": "obj-filter-topics-banner",
                        label: "Assuntos",
                        modelValue: _ctx.topicSelected,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.topicSelected) = $event)),
                        fn: _ctx.removeItem
                      }, null, 8, ["modelValue", "fn"]))
                    : _createCommentVNode("", true),
                  (!_ctx.selectedJuryIsDefault && !_ctx.hideJury && !_ctx.isReview)
                    ? (_openBlock(), _createBlock(_component_filter_banner, {
                        key: 5,
                        "data-cy": "obj-filter-history-banner",
                        label: "Bancas",
                        modelValue: _ctx.jurySelected,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.jurySelected) = $event)),
                        fn: _ctx.setDefaultJury
                      }, null, 8, ["modelValue", "fn"]))
                    : _createCommentVNode("", true),
                  (!_ctx.selectedPeriodIsDefault && !_ctx.isReview)
                    ? (_openBlock(), _createBlock(_component_filter_banner, {
                        key: 6,
                        "data-cy": "obj-filter-timeline-banner",
                        label: "Periodo",
                        modelValue: _ctx.timeline,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.timeline) = $event)),
                        fn: _ctx.setDefaultRange
                      }, null, 8, ["modelValue", "fn"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_q_btn, {
                      disable: _ctx.isReview ? _ctx.notFoundReview : _ctx.notFoundObjectives,
                      loading: _ctx.loading || _ctx.isStarting,
                      "data-cy": "obj-filter-btn",
                      onClick: _ctx.startResolution,
                      padding: "12px 120px",
                      label: _ctx.filterBtn,
                      class: "text-bold",
                      color: "primary",
                      "no-caps": "",
                      glossy: "",
                      push: ""
                    }, null, 8, ["disable", "loading", "onClick", "label"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onBeforeHide"])
        ]),
        _: 1
      }),
      (_ctx.init)
        ? (_openBlock(), _createBlock(_component_objective_shower, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.init)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 0,
          class: "text-center no-padding absolute-bottom",
          square: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item, { class: "no-padding" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "flex flex-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item, { class: "no-padding" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { side: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                              icon: "arrow_back",
                              flat: "",
                              dense: "",
                              round: "",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.page--)),
                              disable: _ctx.isFirstPage
                            }, null, 8, ["disable"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.pageCounter), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, { side: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                              icon: "arrow_forward",
                              flat: "",
                              dense: "",
                              round: "",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.page++)),
                              disable: _ctx.isLastPage
                            }, null, 8, ["disable"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}